export const BROADCAST_LOGGED_OUT_CHANNEL = 'BROADCAST_LOGGED_OUT'
